import { NotificationSettingItemModel } from './notification-setting-item.model';

export class NotificationSettingCategoryModel {
  code: string;
  displayName: string;
  items: NotificationSettingItemModel[];
}
